// @ts-nocheck
import * as types from '../../mutation-types';
import actions from './actions';

const state = {
  pricePrediction: null,
  pricePredictionloading: false,
  pricePredictionError: false,
  pricePredictionCalculationError: false,
};

const mutations = {
  [types.SET_PRICE_PREDICTION](state, result) {
    if (result.errorCode && !result.prediction) {
      state.pricePredictionError = false;
      state.pricePredictionCalculationError = true;
    } else {
      state.pricePrediction = result;
      state.pricePredictionError = false;
      state.pricePredictionCalculationError = false;
    }
  },

  [types.SET_PRICE_PREDICTION_ERROR](state) {
    state.pricePredictionError = true;
  },

  [types.SET_PRICE_PREDICTION_LOADING](state, isLoading) {
    state.pricePredictionloading = isLoading;
  },
};

const getters = {
  pricePrediction: (state) => state.pricePrediction,
  pricePredictionloading: (state) => state.pricePredictionloading,
  pricePredictionError: (state) => state.pricePredictionError,
  pricePredictionCalculationError: (state) => state.pricePredictionCalculationError,
};

export default {
  state,
  getters,
  mutations,
  actions,
};
